// Vstupní bod frontendu aplikace Moodix.
import './styles/app.css';

import htmx from 'htmx.org';
import Alpine from 'alpinejs';

import { initTheme, themeSwitch } from './lib/theme.js';
import { dashboard } from './lib/dashboard.js';
import { chartsControls } from './lib/charts_page.js';
import { terminal } from './lib/terminal.js';
import { calendarTable } from './lib/calendar.js';
import { sortTable } from './lib/table.js';
import { localizeTimes } from './lib/localtime.js';
import { resetPrefs, savePref } from './lib/prefs.js';
import { initLive } from './lib/live.js';
import { initSocket } from './lib/socket.js';
import { enableBrowserNotifications, initNotify } from './lib/notify.js';

window.htmx = htmx;
window.mxSavePref = savePref;
window.mxResetPrefs = resetPrefs;
// Inline JS v hx-on atributech nepoužíváme; vypnuté kvůli CSP
htmx.config.allowEval = false;

// Alpine komponenty
Alpine.data('themeSwitch', themeSwitch);
Alpine.data('dashboard', dashboard);
Alpine.data('chartsControls', chartsControls);
Alpine.data('terminal', terminal);
Alpine.data('calendarTable', calendarTable);
Alpine.data('sortTable', sortTable);
Alpine.data('sidebar', () => ({
  open: false,
  toggle() { this.open = !this.open; document.body.classList.toggle('open', this.open); },
  close() { this.open = false; document.body.classList.remove('open'); },
}));
window.Alpine = Alpine;
Alpine.start();

initTheme();

// Grafy (Highcharts) se načítají jen na stránkách, které nějaký graf obsahují
let charts = null;
async function withCharts(root) {
  if (!root.querySelector('[data-chart]')) return null;
  charts ??= await import('./charts/index.js');
  return charts;
}

document.addEventListener('DOMContentLoaded', async () => (await withCharts(document))?.mountCharts());
// Časy z <time data-fmt> v místním pásmu (i v obsahu načteném přes HTMX)
localizeTimes(document);
// Živé Overview a Dashboard (jen stránka s data-live-root = aktuální období)
initLive();
initNotify();
initSocket();
window.mxEnableBrowserNotifications = enableBrowserNotifications;
// Při hx-swap="outerHTML" je e.detail.target původní (už odpojený) prvek → projít celý dokument
const swapped = (e) => (e.detail.target?.isConnected ? e.detail.target : document);
document.body.addEventListener('htmx:afterSettle', (e) => localizeTimes(swapped(e)));
window.addEventListener('mx:themechange', () => charts?.rerenderCharts());

// HTMX: grafy v nahrazovaném obsahu uvolnit a v novém obsahu namontovat
document.body.addEventListener('htmx:beforeSwap', (e) => charts?.unmountCharts(e.detail.target));
document.body.addEventListener('htmx:afterSettle', async (e) => (await withCharts(e.detail.target))?.mountCharts(e.detail.target));
